module.exports = __webpack_public_path__ + "img/iosstudent.58e3b5a9.png";